import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useChatBotContext } from '$components/chat-bot/chat-bot-context';

export function useContactSupport(onBeforeOpen?: () => void) {
  const { openChat } = useChatBotContext();
  const navigate = useNavigate();

  return useCallback(() => {
    onBeforeOpen?.();
    navigate({ search: '' });
    // Defer openChat so the parent Radix dialog fully closes (via Dialog.Close)
    // before the chatbot dialog opens, preventing pointer-events conflicts.
    setTimeout(() => openChat(), 0);
  }, [openChat, navigate, onBeforeOpen]);
}
